import { Injectable } from '@angular/core';
import {SnackbarData} from './snackbar-data';
import {MatSnackBar, MatSnackBarConfig, MatSnackBarRef} from '@angular/material/snack-bar';
import {CustomSnackBarComponent} from './custom-snack-bar/custom-snack-bar.component';
import {DownloadSnackbarData} from "./download-snackbar/download-snackbar-data";
import {Observable, ReplaySubject} from "rxjs";
import {DownloadSnackbarComponent} from "./download-snackbar/download-snackbar.component";

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {
    ref: MatSnackBarRef<CustomSnackBarComponent> | undefined;
    downloadRef: MatSnackBarRef<DownloadSnackbarComponent> | undefined;
  constructor(private snackbar: MatSnackBar) { }
    private downloadSnackbarData: ReplaySubject<DownloadSnackbarData> = new ReplaySubject<DownloadSnackbarData>(1);

  showMessage(data: SnackbarData) {
      const config: MatSnackBarConfig = {
          panelClass: 'custom-snackbar',
          data: data
      }
      if (!data.action) {
          config.duration = 5000;
      }
      this.ref = this.snackbar.openFromComponent(CustomSnackBarComponent, config);
  }
  hideMessage() {
        if (this.ref) {
            this.ref.dismiss();
        }
        if (this.downloadRef) {
            this.downloadRef.dismiss();
        }
  }
  showDownloadSnackbar() {
      const config: MatSnackBarConfig = {
          panelClass: 'custom-snackbar',
      }
      this.downloadRef = this.snackbar.openFromComponent(DownloadSnackbarComponent, config);
  }
  getDownloadSnackbarData(): Observable<DownloadSnackbarData> {
      return this.downloadSnackbarData. asObservable()
  }
  setDownloadSnackbarData(to: DownloadSnackbarData) {
      this.downloadSnackbarData.next(to);
  }
}
